import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { DurationUnitEnum } from '../../../shared/enums/duration-unit.enum';

import { ReservationInfoPricingItemDto } from './reservation-info-pricing-item.dto';

/**
 * Reservation info DTO
 */
export class ReservationInfoDto {
	reservationUuid?: string;
	@TransformInt()
	vehicleId?: number;
	vehicleUuid?: string;
	@TransformInt()
	vehicleCategoryId?: number;
	vehicleCategoryUuid?: string;
	@TransformDate()
	dateFrom!: Date;
	@TransformDate()
	dateTo!: Date;
	agentUuid?: string;
	durationUnit?: DurationUnitEnum;
	pricingItems?: ReservationInfoPricingItemDto[];
}
